import { Button, Typo } from "@pepperstone/pepper-ui-kit";
import { useState } from "react";

import { ModalContent } from "../../ModalContent";
import { ResponsiveInfoTooltipIcon } from "../../ResponsiveInfoTooltip";
import { TooltipWrapper } from "../../Tooltip";

export const OverviewInfoCardTooltip = ({
  title,
  tooltipText,
  isMobile,
  onHover,
}: {
  title: string;
  tooltipText: string;
  isMobile?: boolean;
  onHover?: (isMobile: boolean) => void;
}) => {
  const [mobileModalOverviewVisible, setMobileModalOverviewVisible] =
    useState(false);

  if (isMobile) {
    return (
      <div
        className="flex flex-row items-center justify-start gap-2 md:justify-end"
        data-testid="overview-info-card-tooltip"
      >
        <MobileOverviewDashboardInfoModal
          isVisible={mobileModalOverviewVisible}
          close={() => setMobileModalOverviewVisible(false)}
          title={title}
          statusDescription={tooltipText}
        />
        <span
          data-testid="overview-info-card-tooltip-icon"
          className="cursor-pointer"
          onClick={() => {
            onHover?.(true);
            setMobileModalOverviewVisible(true);
          }}
        >
          <ResponsiveInfoTooltipIcon iconSize={24} iconType="overview" />
        </span>
      </div>
    );
  }

  return (
    <TooltipWrapper
      data-testid="overview-info-card-tooltip"
      color="blue"
      tooltipPlacement="top"
      text={tooltipText}
      tooltipTextAlign="text-center"
      trackTooltipHover={() => {
        onHover?.(false);
      }}
    >
      <ResponsiveInfoTooltipIcon iconSize={24} iconType="overview" />
    </TooltipWrapper>
  );
};

export const MobileOverviewDashboardInfoModal = ({
  isVisible,
  close,
  title,
  statusDescription,
}: {
  isVisible: boolean;
  close: () => void;
  title: string;
  statusDescription: string;
}) => {
  return (
    <ModalContent isVisible={isVisible} close={close}>
      <div className="flex flex-grow flex-col justify-between gap-4">
        <Typo elem="h1" size="xs" type="heading">
          {title}
        </Typo>
        <Typo
          elem="p"
          size="xs"
          type="label"
          textColor="ps-text-text-primary-secondary"
        >
          {statusDescription}
        </Typo>
        <Button
          data-testid="ok-button"
          as="a"
          variant="ps-btn-primary"
          size="ps-btn-md"
          onClick={close}
        >
          OK
        </Button>
      </div>
    </ModalContent>
  );
};
